// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsFilledSvg from "@ant-design/icons-svg/es/asn/SnippetsFilled";
import AntdIcon from '../components/AntdIcon';

var SnippetsFilled = function SnippetsFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsFilledSvg
  }));
};

SnippetsFilled.displayName = 'SnippetsFilled';
export default React.forwardRef(SnippetsFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SnippetsFilled.js
// module id = 1843
// module chunks = 0